<script lang="ts" setup>
import ogImage from '~/assets/images/chatbot/og_image.jpg';

const config = useRuntimeConfig();
const { t, locale } = useI18n();
const getImage = useImage();

useHead({
  title: t('meta.title'),
  meta: [
    { name: 'description', content: t('meta.description') },
    { property: 'og:title', content: t('meta.title') },
    { property: 'og:description', content: t('meta.description') },
    { property: 'og:type', content: 'website' },
    { property: 'og:locale', content: locale.value },
    {
      property: 'og:image',
      content: `${config.public.siteUrl}${getImage(ogImage, { width: 1200 })}`,
    },
    { property: 'og:image:width', content: 1200 },
    { property: 'og:image:height', content: 642 },
  ],
});
</script>

<template>
  <main>
    <SectionChatbotWelcome />
    <LazyIdleSectionChatbotRules hydrate-on-idle />
    <LazyIdleSectionChatbotBanner hydrate-on-idle />
    <LazyIdleSectionChatbotOfficial hydrate-on-idle />
  </main>
</template>

<i18n>
ru:
  meta:
    title: 'Бьюти-фейлы, которые достойны iPhone – DTMS'
    description: 'Расскажи о своём самом смешном бьюти-фейле, участвуй в конкурсе от DTMS и получи шанс выиграть новый iPhone. Потому что фейлы – это тоже забота о себе!'

en:
  meta:
    title: 'Beauty fails worthy of an iPhone – DTMS'
    description: 'Share your funniest beauty fail, join the DTMS contest, and get a chance to win a new iPhone. Because fails are part of self-care too!'
</i18n>
